import { Pagination, PaginationItem } from "@mui/material";
import React from "react";

const CommanPagination = ({
  currentPage,
  setCurrentPage,
  limit,
  totalCounts,
}) => {
  const totalPages = Math.ceil(totalCounts / limit);

  const startEntry = (currentPage - 1) * limit + 1;
  const endEntry = Math.min(currentPage * limit, totalCounts);

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  return (
    <div className="pages_listst">
      <div className="row mt-4 align-items-center">
        <div className={totalCounts > 0 ? "col-lg-6" : "col-lg-12"}>
          <div className="list_cnts">
            {totalCounts > 0 ? (
              totalCounts > limit ? (
                `Showing ${startEntry} to ${endEntry} of ${totalCounts} entries`
              ) : (
                `Showing all ${totalCounts} entries`
              )
            ) : (
              <div className="no-entries"></div>
            )}
          </div>
        </div>

        <div className="col-lg-6 d-flex justify-content-lg-end justify-content-center mt-3 mt-lg-0">
          {totalCounts > limit && (
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              shape="rounded"
              siblingCount={1}
              boundaryCount={1}
              className="custom-pagination"
              renderItem={(item) => (
                <PaginationItem
                  {...item}
                  className={`custom-pagination-item ${
                    item.selected ? "active" : ""
                  } ${item.type === "previous" || item.type === "next" ? "arrow" : ""} ${
                    item.type === "ellipsis" ? "dots" : ""
                  }`}
                />
              )}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CommanPagination;
